import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { Component, input, output, signal, viewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  imports: [CdkCopyToClipboard, MatIcon, MatTooltip],
  selector: 'avs-copy',
  styleUrl: './copy.component.scss',
  templateUrl: './copy.component.html',
})
export class CopyComponent {
  copied = output();
  value = input.required<string>();

  protected matTooltip = viewChild(MatTooltip);
  protected tooltipMessage = signal('Copy to clipboard');

  protected copy() {
    const tooltip = this.matTooltip()!;

    setTimeout(() => {
      tooltip.message = 'Copied';
      tooltip.show();
    });
    setTimeout(() => tooltip.hide(), 2000);
    setTimeout(() => tooltip.message = this.tooltipMessage(), 2500);

    this.copied.emit();
  }
}
